const amplifyConfig = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:a23f9473-a021-4e29-9b59-91f89fc9c647",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_XR8LIbnVD",
    "aws_user_pools_web_client_id": "4inqii5uufun1djhuuhu0shqiu",
    "oauth": {},
    "aws_content_delivery_bucket": "jd-market-admin-returns-prod",
    "aws_content_delivery_bucket_region": "eu-west-1",
    "aws_content_delivery_url": "http://jd-market-admin-returns-prod.s3-website-eu-west-1.amazonaws.com",
    "aws_cloud_logic_custom": [
        {
            "name": "adminUsersAPI",
            "endpoint": "https://4qgy2h325j.execute-api.eu-west-1.amazonaws.com/prod",
            "region": "eu-west-1"
        }
    ],
    "aws_dynamodb_all_tables_region": "eu-west-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "adminReturnsUsers-prod",
            "region": "eu-west-1"
        }
    ]
};

export default amplifyConfig;
